(function () {
  if (window.updateConfiguredPriceDisplay) return;

  // Shared "write a computed total into the PDP price markup" step, used by
  // any configurator (seat-configurator, modular-configurator, ...) that
  // replaces a single-variant price with the sum of several resolved
  // variants. Each caller computes its own `total`/`compareTotal` (in cents)
  // from its own model - this just does the DOM writes, identically, into
  // whichever price/sticky-price/button wrappers exist.
  window.updateConfiguredPriceDisplay = function (options) {
    var priceWrapper = options.priceWrapper;
    var stickyWrapper = options.stickyWrapper;
    var total = options.total;
    var compareTotal = options.compareTotal;
    var sectionId = options.sectionId || '';
    var saveAmountTemplate = options.saveAmountTemplate || 'Save __AMOUNT__';

    var onSale = compareTotal > total;

    [priceWrapper, stickyWrapper].forEach(function (wrapper) {
      if (!wrapper) return;
      var priceRoot = wrapper.querySelector('.price');
      if (priceRoot) priceRoot.classList.toggle('price--on-sale', onSale);
      priceRoot && priceRoot.classList.remove('price--sold-out');

      var regularEl = wrapper.querySelector('.price__regular .price-item--regular');
      var saleEl = wrapper.querySelector('.price__sale .price-item--sale');
      var compareEl = wrapper.querySelector('.price__compare .price-item--regular');

      if (regularEl) regularEl.textContent = formatMoney(total);
      if (saleEl) saleEl.textContent = formatMoney(total);
      if (compareEl) compareEl.textContent = onSale ? formatMoney(compareTotal) : '';
    });

    var saveTagEl = priceWrapper && priceWrapper.querySelector('.price__save-tag');
    if (saveTagEl) {
      saveTagEl.hidden = !onSale;
      saveTagEl.textContent = onSale
        ? saveAmountTemplate.replace('__AMOUNT__', formatMoney(compareTotal - total))
        : '';
    }

    ['product-form-' + sectionId, 'sticky-bar-product-form-' + sectionId].forEach(function (formId) {
      var form = sectionId ? document.getElementById(formId) : null;
      var buttonPriceEl = form ? form.querySelector('.product-form__submit-price') : null;
      if (buttonPriceEl) buttonPriceEl.textContent = ' · ' + formatMoney(total);
    });
  };
})();
